var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { GenericAdapter } from './GenericAdapter';
import { CONSENT } from '../types/consent';
import { eventToTuple } from '../utils';
/**
 * Base GTM Adapter that can be extended to send platform-specific events that also exist in GTM.
 */
var GTMAdapter = /** @class */ (function (_super) {
    __extends(GTMAdapter, _super);
    function GTMAdapter(platform, consent, payloadConverter) {
        if (consent === void 0) { consent = CONSENT.DEFER; }
        if (payloadConverter === void 0) { payloadConverter = GTMAdapter
            .payloadConverter.object; }
        var _this = _super.call(this) || this;
        _this.platform = platform;
        _this.consent = consent;
        _this.payloadConverter = payloadConverter;
        _this.isReady = false;
        if (typeof window !== 'undefined') {
            window.dataLayer = window.dataLayer || [];
            // Listen for GTM to be ready
            window.addEventListener('__bom_HiveReady', function () { return _this.broadcastReady(); }, {
                once: true
            });
        }
        return _this;
    }
    GTMAdapter.prototype.track = function (obj) {
        if (typeof window === 'undefined')
            return;
        window.dataLayer = window.dataLayer || [];
        if (this.platform) {
            window.dataLayer.push({
                event: 'hive_event',
                hivePlatform: this.platform,
                hivePayload: this.payloadConverter(obj),
                _clear: true
            });
        }
        else {
            var eventName = obj.eventName, rest = __rest(obj, ["eventName"]);
            window.dataLayer.push(__assign({ _clear: true, event: eventName }, rest));
        }
    };
    /**
     * A set of payload converters for different formats.
     * - `object`: Returns the event object as is.
     * - `params`: Returns an array with the first item as `eventName` and the second as an object with any additional EventObject properties.
     */
    GTMAdapter.payloadConverter = {
        /**
         * Returns the event object as is.
         */
        object: function (obj) { return obj; },
        /**
         * An array with the first item as `eventName` and the second as an object with any additional EventObject properties.
         */
        params: eventToTuple
    };
    return GTMAdapter;
}(GenericAdapter));
export { GTMAdapter };
